/**
 * Created by Languagenut on 28/08/2019.
 */

import React  from 'react';
import {Card} from 'react-bootstrap';
import Translation from '../../../store/internationalization-store.js';
import StringTask from '../../../components/TaskNamesList';
import Popup from '../../../components/popup/comfirmation_popup.js';
export default class EsxistingSummary extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            show:false
        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.setState({update:true});
    }

    select(task){
        this.setState({
            show:!this.state.show,
            task:task,
            title:new StringTask({tasks:[task]}).returnString()
        })
    }

    renderSections(){
        let body = [];

        var module = this.props.tasks || [];
        if (module.length > 0) {

            var b = [];

            console.log(this.props.tasks);

            for(var i = 0 ; i < this.props.tasks.length; i ++)
            {
                var titleString = new StringTask({tasks:[this.props.tasks[i]]}).returnString();
                if (this.props.onRemove != undefined) {
                    b.push(<Card onClick={this.select.bind(this , this.props.tasks[i])}style={{margin:'5px' , padding:'5px'}} ><p style={{padding:0, margin:0}}><i style={{padding:0}} class="hyperlink fas fa-trash-alt"></i>&nbsp;&nbsp;{titleString}&nbsp;</p></Card>);
                } else {
                    b.push(<Card style={{margin:'5px' , padding:'5px'}} >
                                <p style={{padding:0, margin:0}}>{titleString}</p></Card>); 
                }
            }

            body.push(
                <Card className="summary_container" style={{padding:"5px"}}>
                    <div>
                        {b}
                    </div>
                </Card>
            );

        } else {
            body.push(
                <Card body>
                    <div>
                    <Card style={{padding:"10px"}}><b>{Translation.get(12713, 'No content selected')}</b></Card>
                   </div>
                </Card>
            )
        }

        return body;
    }

    render(){
        return <div defaultActiveKey="0">

            <Popup title={this.state.title} onSave={()=>{ this.props.onRemove(this.state.task);}} onHide={()=>{this.setState({show:false})}} show={this.state.show} body={Translation.get(12714 , 'Are you sure you wish to delete the task?')} />
            {this.renderSections()}

        </div>
    }

}